import React from "react";
import { HeaderNavItems } from "../../helperFunction";
import { Link, useLocation } from "react-router-dom";
import logoImg from "../../assets/logodm.png";
import DrawerMenu from "../drawer";
import "./styles.scss";

const Header = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  console.debug("currentPath>>>>>>>>>>>>>>>>>>>", currentPath);
  return (
    <section className="header-container">
      <section className="logo-section">
        <Link to="/">
          <img src={logoImg} alt="logo-img" className="logo-img" />
        </Link>
      </section>
      <section className="nav-items-section">
        {HeaderNavItems?.map((e) => {
          return (
            <Link
              to={e?.path}
              className={`link-item ${
                e?.path === currentPath ? "contact-link-item" : ""
              }`}
            >
              {e?.pageName}
            </Link>
          );
        })}
      </section>
      <DrawerMenu />
    </section>
  );
};

export default Header;
